import React from 'react';
import PropTypes from 'prop-types';
import DraggableItem from './DraggableItem';

const DraggableListItems = props => (
  <React.Fragment>
    {!props.items.length ? (
      <div className={props.placeholderClassName}>{props.placeholder}</div>
    ) : (
      props.items.map((item, index) => {
        return (
          <DraggableItem
            {...props}
            {...item}
            key={item.name}
            draggableId={item.name}
            index={index}
            isDragDisabled={item.isDragDisabled}
            disableInteractiveElementBlocking
          >
            {item.label}
          </DraggableItem>
        );
      })
    )}
  </React.Fragment>
);

DraggableListItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  placeholderClassName: PropTypes.string,
  placeholder: PropTypes.string
};

DraggableListItems.defaultProps = {
  placeholderClassName: 'empty-placeholder',
  placeholder: ''
};

export default DraggableListItems;
